export default __webpack_public_path__ + "static/media/welpentreffen_23.30dfd455.jpg";